<template>
  <div class="flight-details-container">
    <div class="flex-form-container">
      <div class="header-text-info">Maneuvering Speed (Va)</div>
      <div class="flight-info-sub">Va = Vs × √(W / Wmax)</div>
      <div class="grid gap-sm" :style="$global.dynamicColsV2(1, .1, 1)">
        <div class="relative">
          <input class="text-end" id="currentWeight" type="text" v-model="form.currentWeight">
          <label for="currentWeight" class="custom-placeholder start">√(Current Weight)</label>
        </div>
        <div class="relative center">/</div>
        <div class="relative">
          <input type="text" v-model="form.maxWeight">
          <div class="custom-placeholder">(Wmax)</div>
        </div>
      </div>
      <div class="grid gap-sm" :style="$global.dynamicColsV2(.07, .9, .1, 1)">
        <div class="relative center">x</div>
        <div class="relative">
          <input type="text" v-model="form.vaAtWmax">
          <label class="custom-placeholder">(VA @ Wmax)</label>
        </div>
        <div class="relative center">=</div>
        <div class="relative">
          <input type="text" style="color: green" readonly :value="maneuverSpeed">
          <label class="custom-placeholder">(Mnvr Speed)</label>
        </div>
      </div>
    </div>

    <div class="flex-form-container">
      <div class="header-text-info">Pressure Altitude</div>
      <div class="flight-info-sub">Pressure Altitude = [(29.92 − Current Pressure) × 1,000] + Field Elevation</div>
      <div class="grid gap-sm" :style="$global.dynamicColsV2(1, .1, 1)">
        <div class="relative">
          <input class="text-end" id="standardPressure" type="text" v-model="form.currentPressure">
          <label for="standardPressure" class="custom-placeholder start">Standard Pressure =</label>
        </div>
        <div class="relative center">-</div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.currentPressure">
          <div class="custom-placeholder">(Current Pressure)</div>
        </div>
      </div>

      <div class="grid gap-sm" :style="$global.dynamicColsV2(.3, .5, .07, 1, .07, .5)">
        <div class="relative">x 1000 =</div>
        <input type="text" class="text-center" :value="pressureAltitude" readonly>
        <div class="relative">+</div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.fieldElevation">
          <div class="custom-placeholder">(Field Elevation)</div>
        </div>
        <div class="relative">=</div>
        <input type="text" style="color: green" class="text-center" :value="pressureAltitude" readonly>
      </div>
    </div>

    <div class="flex-form-container">
      <div class="header-text-info">Density Altitude</div>
      <div class="flight-info-sub">Density Altitude = Pressure Altitude + [120 × (OAT − ISA Temp)]</div>
      <div class="grid gap-sm" :style="$global.dynamicColsV2(1, .4, 1)">
        <div class="relative">
          <input class="text-end" id="standardPressure" type="text" v-model="form.pressureAltitude">
          <label for="standardPressure" class="custom-placeholder start">(Pressure Altitude)</label>
        </div>
        <div class="relative center">+ [ 120x</div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.oat">
          <div class="custom-placeholder">(OAT)</div>
        </div>
      </div>

      <div class="grid gap-sm" :style="$global.dynamicColsV2(.07, .9, .1, 1)">
        <div class="relative center">-</div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.isaTemp">
          <label class="custom-placeholder">(ISA)</label>
        </div>
        <div class="relative center">] =</div>
        <div class="relative">
          <input class="text-center" type="text" style="color: green" :value="densityAltitude" readonly>
        </div>
      </div>
    </div>

    <div class="flex-form-container">
      <div class="grid gap-sm" :style="$global.dynamicColsV2(.7, 1, 1)">
        <div class="relative">
          <div class="header-text-info">Performance</div>
        </div>
        <div class="relative">
          <div>Ground Roll</div>
        </div>
        <div class="relative">
          <div>50ft Obstacle</div>
        </div>
      </div>

      <div class="grid gap-sm" :style="$global.dynamicColsV2(.7, 1, 1)">
        <div class="relative">Short Field Takeoff</div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.shortFieldTakeoffGroundRoll">
        </div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.shortFieldTakeoffObstacle">
        </div>
      </div>

      <div class="grid gap-sm" :style="$global.dynamicColsV2(.7, 1, 1)">
        <div class="relative">Short Field Landing</div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.shortFieldLandingGroundRoll">
        </div>
        <div class="relative">
          <input type="text" placeholder="Enter..." v-model="form.shortFieldLandingObstacle">
        </div>
      </div>

      <div class="grid gap-sm mt-3" :style="$global.dynamicColsV2(1)">
        <div class="header-text-info">Notes</div>
        <div class="relative">
          <textarea placeholder="Type here..." rows="4" v-model="form.notes">
          </textarea>
        </div>
      </div>
    </div>

    <div>
      <button class="primary" @click="$emit('next')">Next</button>
    </div>
  </div>
</template>

<script>

import weightBalance from "@/components/HiloComponents/WeightBalance.vue";

export default {
  props: {
    toast: {
      type: Object,
      required: true,
      default: () => {}
    },
    dispatchId: {
      type: Number
    },
    weightBalance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        currentWeight: "",
        maxWeight: "",
        vaAtWmax: "",
        currentPressure: "",
        fieldElevation: "",
        oat: "",
        isaTemp: "",
        shortFieldTakeoffGroundRoll: "",
        shortFieldTakeoffObstacle:"",
        shortFieldLandingGroundRoll: "",
        shortFieldLandingObstacle: "",
      }
    };
  },
  async mounted() {

  },
  computed: {
    maneuverSpeed() {
      const W = parseFloat(this.form.currentWeight) || 0;
      const Wmax = parseFloat(this.form.maxWeight) || 1;
      const VaMax = parseFloat(this.form.vaAtWmax) || 0;
      return VaMax * Math.sqrt(W / Wmax) || 0;
    },
    pressureAltitude() {
      const standardPressure = 29.92;
      const currentPressure = parseFloat(this.form.currentPressure) || 0;
      const fieldElevation = parseFloat(this.form.fieldElevation) || 0;
      return ((standardPressure - currentPressure) * 1000) + fieldElevation;
    },
    densityAltitude() {
      return this.pressureAltitude + 120 * ((parseFloat(this.form.oat) || 0) - (parseFloat(this.form.isaTemp) || 0));
    },
  }
};
</script>

<style>
.flight-details-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 600px;
}
.header-text-info {
  font-weight: bold;
  color: #404040;
}
.flight-info-sub {
  font-weight: normal;
  font-size: 13px;
}
.gap-sm {
  gap: 10px !important;
  align-items: center;
}
.center {
  text-align: center;
}
.text-end {
  text-align: right;
}
.custom-placeholder.start {
  left: 15px !important;
}
.flex-form-container label {
  font-weight: unset !important;
  font-size: unset !important;
  text-transform: lowercase !important;
  text-transform: capitalize !important;
}
.grid textarea {
  width: 100%;
  border: none;
  background: #f5f5f5;
  padding: 15px;
  border-radius: 10px;
  outline: none;
}
</style>
